import Vue from 'vue';
import PostList from '@/components/post-list/PostList.vue';

/**
 * The default base for any category view
 * Purpose is to include meta data for each category
 */
export default Vue.extend({
	props: {
		categoryId: {
			type: Number,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		meta: {
			type: Array,
			required: true,
		},
	},
	metaInfo() {
		return {
			title: this.title,
			meta: this.meta as any[],
		};
	},
	components: {
		PostList,
	},
});
